__webpack_require__.p = "/Kurumsal/";